import { useRouter } from "next/router"

export function useLimit(): number | undefined {
  let limit: number | undefined

  try {
    const router = useRouter()
    let limitStr = (router.query.limit as string) || ""
    if (limitStr != "" && limitStr.length) {
      limit = parseInt(limitStr) || undefined
    }
  } catch (err) {
    console.error(err)
  }

  return limit
}

export function useOffset(): number | undefined {
  let offset: number | undefined

  try {
    const router = useRouter()
    let offsetStr = (router.query.offset as string) || ""
    if (offsetStr != "" && offsetStr.length) {
      offset = parseInt(offsetStr) || undefined
    }
  } catch (err) {
    console.error(err)
  }

  return offset
}
